<template>
    <div class="card mb-0 shadow">
        <div class="card-body">
            <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                    <div class="row">
                        <div class="col-12">
                            <h4 class="font-weight-bold">Desligamentos</h4>
                        </div>
                        <load v-if="loading" mode="table" />
                        <div v-else class="col-12 mb-3">
                            <table
                                class="table table-bordered bg-white table-sm"
                                v-for="historico in historicos"
                                :key="historico.id"
                            >
                                <tr>
                                    <td class="bg-gray" colspan="2">
                                        O Status deste <b>Acompanhamento</b> foi
                                        atualizado de
                                        <b>{{
                                            getStatusTitulo(
                                                parseInt(
                                                    historico.status_anterior
                                                )
                                            )
                                        }}</b>
                                        para
                                        <b>{{
                                            getStatusTitulo(
                                                parseInt(historico.status_atual)
                                            )
                                        }}</b>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        Técnico: <b>{{ historico.user_id }}</b>
                                    </td>
                                    <td>Data:{{ historico.created_at }}</td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <p><b>Motivo da atualização</b></p>
                                        <p>
                                            <b>{{
                                                getMotivo(historico.motivo)
                                            }}</b>
                                        </p>
                                        <span
                                            v-html="historico.observacoes"
                                        ></span>
                                    </td>
                                </tr>
                            </table>
                            <h4
                                class="text-secondary"
                                v-if="historicos.length <= 0"
                            >
                                <i
                                    class="mdi mdi-24px mdi-alert-decagram-outline"
                                ></i>
                                Nenhum desligamento registrado.
                            </h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["acompanhamento", "status"],
    data() {
        return { historicos: {}, loading: false };
    },
    mounted() {
        this.getHistorico();
    },
    methods: {
        getMotivo(id) {
            const result = this.$root.arrays.motivo_desligamento.filter(
                (item) => item.id == id
            );
            return result ? result[0].value : "";
        },
        getStatusTitulo(id) {
            //console.log(id);
            if (this.status.length != undefined) {
                const result = this.status.filter((item) => item.id == id);
                return result[0] ? result[0].value : "";
            }
        },
        getHistorico() {
            this.loading = true;
            axios
                .get(
                    "api/dashboard/acompanhamento/historico/status/" +
                        this.acompanhamento.id
                )
                .then((response) => {
                    this.historicos = response.data;
                })
                .finally(() => {
                    this.loading = false;
                })
                .catch(() => {
                    this.$router.push(
                        "/dashboard/acompanhamentos/edit/" +
                            this.acompanhamento.id +
                            "?familia_id=" +
                            this.acompanhamento.familia_id
                    );
                });
        },
    },
};
</script>
